import React, { FunctionComponent } from "react";

import { MenuComponent } from "../MenuComponent";
import { NotificationList } from "../NotificationList";

/** Sekce menu pro notifikační položky dané notifikační skupiny. */
export const NotificationMenu: FunctionComponent = () => (
    <MenuComponent isPlain={true}>
        <NotificationList />
    </MenuComponent>
);
